export class Bankdetails {

  bankaddress: string;
  bankId: number;
  sortcode: number;
  acholdername: string;
  accountnumber: number;
  modeOfPayment: number;
  monthlypaymentdays: number;
  direct_debit_guarantee_indicator: boolean;
  bnk_rm_Paf_Id:number;
  BankPostcode:string;
}

export class esigndetail {
  cust_id: number;
  UserId: number;
  PhoneNo: string;
  Type: string;
  quoteId: Number;
  titleId: string;
  notes:string;
  firstname: string;
  middlename: string;
  lastname: string;
  RegCompanyName: string;
  CompanyRegNo: string;
  businessname: string;
  emailaAddress: string;
  emailaAddress2: string;
  businessaddress1: string;
  businessaddress2: string;
  telephoneNo: string;
  BillTown: string;
  Postcode: string;
  Letter: boolean;
  Phone: boolean;
  Email: boolean;
  csd: string;
  ced: string;
  EmailId: string;
  billing_contact_name: string;
  contractFileFullPath: string;
  contractFileName: string;
  esignApproval: string;
  address_id: number;
  siteaddress_id: number;
  rm_Paf_Id: number;
  cmp_rm_Paf_Id: number;
  bill_address_id: number;
  site_address_id: number;
  reg_company_name: string;
  email: string;
  microbusiness_indicator: boolean;
  groupname: string;
  group_user_name: string;
  vat_indicator: boolean;
  fileUpload: File;
  vatfile_name: string;
  CompanyPostcode: string;
  emergencycontacttelephoneno: string;
  emergencycontactname: string;
  emergencycontactemailaddress: string;
  site_reference_id: string;
  sameAsCompanyAddress: boolean;
  billing_rm_Paf_Id: Number;
  site_rm_Paf_Id: Number;
  BuildingNo: string;
  BuildingName: string
  SubBuildingName: string;
  PostTown: string;
  postcode: string;
}

export class pdfname {
  contract_file_name: string;
  contract_file_full_path: string;

}
export class clsEsign {
  Esign: esigndetail;
  Bank: Bankdetails;

}

export class VatEsign {
  vat_indicator: boolean;
  fileUpload: File;
  quoteId: Number;
  modifiedid: string;

}

export class soldlist {
  cust_id: Number;
  sPID: string;
  business_name: string;
  contractStartDate: string;
  contractEndDate: string;
  cust_Status: string;
}